import React, {useContext, useEffect, useRef, useState} from "react";
import FileAttach from "../../../../../../images/Attachments.svg";
import {Button} from "../../../../../../stories/Button/Button";
import {AppContext} from "../../../../../../context/context";
import {Operation} from "../../../../../../utils/Enum.types";
import {useLazyQuery, useMutation} from "@apollo/client";
import {
  AtsTicketsByNodeData,
  AtsTicketsByNodeForStatus,
  GetTicketDetailsForFollowUp,
} from "../../../masters/items/queries/queries";
import {nodeVar} from "../../../../../../utils/commonQueryTypes";

import {MapsContext} from "../../context/context";
import {emptyMessage, TicketStatus} from "../../../../../../utils/constants";
import {mapsPayloadType} from "../../context/reducer";
import {AddTicketDetails} from "../../../masters/items/queries/mutations";
import {
  AddTicketDetailsResult,
  AddTicketDetailsVariables,
} from "../../../masters/items/queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import {toIsoDate} from "../../../../../../utils/UtilFunctions";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import {handleUploadAndDownloadFile} from "../../../../../../utils/Upload";
import MessageModal from "../../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../../pages/LoadingModal";
import Close from "../../../../../../images/Close.svg";

export interface StateTypes {
  vendorId: number;

  flag: boolean;
}

export interface ResolveTypes extends StateTypes {
  flag: boolean;
  vendorId: number;
  junctionId: number;
}

interface Props {
  setSuccessMessage: React.Dispatch<React.SetStateAction<boolean>>;
  setSlaModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddSlaExemption = ({setSuccessMessage, setSlaModal}: Props) => {
  const [file, setFile] = useState<FileList | null>(null);

  const [mutationCompleted, setMutationCompleted] = useState(false);

  const [message, setMessage] = useState(emptyMessage);
  const [remark, setRemark] = useState("");

  const [progress, setProgress] = useState(0);

  const {customer_id} = useUrlParams();
  const {user_details} = useLoggedInUserDetails();

  const value = useRef("");

  const [GetTicketById, {data}] = useLazyQuery<AtsTicketsByNodeData, nodeVar>(
    AtsTicketsByNodeForStatus
  );

  const handleClear = () => {
    setRemark("");
    setFile(null);
    value.current = "";
    dispatch({
      type: mapsPayloadType.EMP,
      payload: {
        empId: 0,
      },
    });
  };

  const {serverDate} = useServerDateandTime();

  const [addTicket, {loading}] = useMutation<
    AddTicketDetailsResult,
    AddTicketDetailsVariables
  >(AddTicketDetails, {
    onError: (e) =>
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      }),
  });

  const {state} = useContext(AppContext);
  const {state: mapsState, dispatch} = useContext(MapsContext);

  const handleImagePreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      let image_as_files = e.target.files;
      setFile(image_as_files);
    }
  };

  useEffect(() => {
    if (mapsState.ticketId) {
      GetTicketById({
        variables: {
          id: mapsState.ticketId,
        },
      });
    }
  }, [mapsState.ticketId, GetTicketById]);

  const handleSubmit = async () => {
    setMutationCompleted(true);
    if (file === null || (file && file[0] === undefined)) {
      setMessage({
        flag: true,
        message: "Attachment is required",
        operation: Operation.NONE,
      });
      setMutationCompleted(false);
      return;
    }
    if (file && file[0]) {
      const ext = file?.[0].name.split(".").pop();

      let filename = `${state.companyId}/ticketDetails/${file?.[0].name}.${ext}`;
      addTicket({
        variables: {
          customerID: customer_id!,
          ticketID: mapsState.ticketId,
          todaysDate: toIsoDate(serverDate),
          user_details,
          deviceTypes: [],
          input: {
            assignedID: mapsState.empId,
            status: TicketStatus.EXEMPTED,
            remarks: value.current,
            imagesPath: filename,
          },
          assetDetails: [],
        },
        refetchQueries: [
          {
            query: GetTicketDetailsForFollowUp,
            variables: {
              customerID: customer_id!,
              ticketID: mapsState.ticketId,
            },
          },
        ],
      }).then(async ({data}) => {
        if (data && data.AddTicketDetails) {
          if (file && file[0]) {
            const ext = file[0].name.split(".").pop();
            const awsFilename = `${state.companyId}/ticketDetails/${data.AddTicketDetails.id}.${ext}`;
            const uploadFilePromise = await handleUploadAndDownloadFile(
              file[0],
              awsFilename,
              setProgress,
              false
            );

            if (uploadFilePromise) {
              setMessage({
                flag: true,
                message: "Ticket updated successfully",
                operation: Operation.CREATE,
              });
              setSuccessMessage(true);
              setMutationCompleted(false);
            } else {
              setMessage({
                flag: true,
                message: "File upload failed",
                operation: Operation.NONE,
              });
              setMutationCompleted(false);
            }
          } else {
            setMessage({
              flag: true,
              message: "Ticket updated successfully",
              operation: Operation.CREATE,
            });
            setMutationCompleted(false);
          }
        }
      });
    }
  };

  const messageModalClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
    }
    setMessage(emptyMessage);
  };

  if (data) {
    return (
      <>
        <div className="junc-follow-up__data--flex">
          <b>Add SLA Exemption</b>
          <img
            src={Close}
            onClick={() => {
              setSlaModal(false);
            }}
          />
        </div>
        <div className="junc-follow-up__data--user-input">
          <label className="junc-follow-up__data--input">
            <input
              type="text"
              placeholder="Type here..."
              className="junc-follow-up__data--textinput"
              id="file-name-display"
              autoFocus
              onChange={(e) => {
                value.current = e.target.value;
                setRemark(e.target.value);
              }}
              value={remark}
            />

            <img
              src={FileAttach}
              alt="Attach file"
              className="browse-icon"
              onClick={() => {
                const inputFile = document.getElementById(
                  "student-documents__browse--inputTag"
                );
                if (inputFile) {
                  inputFile.click();
                }
              }}
            />
            <input
              id="student-documents__browse--inputTag"
              type="file"
              className="junc-follow-up__data--choose-file"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleImagePreview(e);
              }}
              accept="image/jpg, image/png, image/jpeg"
            />
          </label>
        </div>
        <div>
          <Button
            mode="save"
            onClick={() => {
              handleSubmit();
            }}
          ></Button>
          <Button
            mode="cancel"
            onClick={() => {
              setSlaModal(false);
            }}
          ></Button>
        </div>

        <LoadingModal flag={loading} />

        <MessageModal
          handleClose={messageModalClose}
          modalFlag={message.flag}
          operation={message.operation}
          value={message.message}
        />
      </>
    );
  } else return <b className="nodata">data not found</b>;
};

export default AddSlaExemption;
